import { useEffect, useState } from 'react';
import Layout from '../../components/layout';
import { Loading_ellipsis } from '../../components/loading';
import SportCardsService from '../../components/sportCards/sportCardsService';
import { useStore } from '../../stores/use_global_state';
import styles from './sportCards.module.scss';
import { useRouter } from 'next/router';


export default function SportCards() {
  const router = useRouter();
  const { state } = useStore();
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      try {
        if (!state.load) {
          return;
        }

        if (!state.isAuth) {
          await router.push('/');
          return;
        }

        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    checkAuthAndRedirect();
  }, [state, router]);

  return (
    <Layout>
      {loading
        ?
        <section className={`${styles.loading} sportCards`}>
          <Loading_ellipsis big={true} />
        </section>

        :
        <section className={`${styles.section} sportCards`}>
          <h1 className={styles.pageTitle}>Sport Cards Generator</h1>
          <SportCardsService />
        </section>
      }

    </Layout>
  )
}